import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatChip } from '@angular/material/chips';
import { TranslateModule } from '@ngx-translate/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

interface ICellRendererParamsWithCustomProps extends ICellRendererParams {
  classes?: string;
  chipClasses?: string;
}

@Component({
    selector: 'app-cell-chip',
    templateUrl: './cell-chip.component.html',
    imports: [CommonModule, TranslateModule, MatChip],
    styleUrls: ['./cell-chip.component.scss']
})
export class CellChipComponent implements ICellRendererAngularComp {
  public text = '';
  public classes = '';
  public chipClasses = '';

  public agInit(params: ICellRendererParamsWithCustomProps): void {
    this.text = params.valueFormatted ?? params.value ?? '';
    this.classes = params?.classes || '';
    this.chipClasses = params?.chipClasses || '';
  }

  public refresh(params: ICellRendererParams<string>): boolean {
    this.text = params.valueFormatted ?? params.value ?? '';
    return true;
  }
}
